module.exports = __webpack_public_path__ + "static/img/newsBd.4781a56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newsBd.jpg
// module id = UgaR
// module chunks = 0